"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBetLimit = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var useBetLimit = function () {
    var _a, _b;
    var isAuth = (0, user_1.useIsAuthorized)();
    var _c = (0, useQuery_1.useQuery)({
        canRender: isAuth,
        path: keys_1.GET_BET_LIMITS,
        revalidateOnMount: true,
    }), data = _c.data, error = _c.error, isLoading = _c.isLoading, isValidating = _c.isValidating, mutate = _c.mutate;
    return {
        data: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0],
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
        mutate: mutate,
    };
};
exports.useBetLimit = useBetLimit;
